<template>
  <span
    :class="mergedClasses"
    tabindex="0"
    @mouseenter="repositionTooltip"
    @focus="repositionTooltip"
    v-bind="forwardedAttrs"
  >
    <slot />
    <span
      v-if="tooltip"
      :id="computedTooltipId"
      ref="tooltipRef"
      role="tooltip"
      class="pointer-events-none fixed z-20 rounded-md bg-gray-900 px-2.5 py-1 text-[0.7rem] font-medium text-white opacity-0 shadow-lg ring-1 ring-black/40 transition-opacity duration-150 group-hover:opacity-100 group-focus:opacity-100 whitespace-normal max-w-[85vw]"
    >{{ tooltip }}</span>
  </span>
</template>

<script>
let uid = 0

export default {
  name: 'DashboardTooltipPill',
  inheritAttrs: false,
  props: {
    tooltip: {
      type: String,
      default: ''
    },
    tooltipId: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: 'pill'
    }
  },
  data () {
    return {
      uidSuffix: ++uid
    }
  },
  computed: {
    baseClasses () {
      if (this.variant === 'text') {
        return 'group relative inline-flex min-w-0 items-center'
      }
      return 'group relative inline-flex items-center gap-1 rounded-full border border-primary-100 bg-white/80 px-2 py-0.5 text-[0.7rem] font-semibold text-primary-600'
    },
    mergedClasses () {
      const extra = this.$attrs.class
      if (!extra) return this.baseClasses
      return [this.baseClasses, extra]
    },
    forwardedAttrs () {
      const { class: _unused, ...rest } = this.$attrs
      return rest
    },
    computedTooltipId () {
      if (!this.tooltip) {
        return null
      }
      return this.tooltipId || `dashboard-tooltip-pill-${this.uidSuffix}`
    }
  },
  methods: {
    repositionTooltip () {
      if (!this.tooltip) {
        return
      }
      this.$nextTick(() => {
        const tooltip = this.$refs.tooltipRef
        if (!tooltip) {
          return
        }
        tooltip.style.position = 'fixed'
        tooltip.style.left = '0px'
        tooltip.style.top = '0px'
        tooltip.style.transform = 'none'
        tooltip.style.visibility = 'hidden'
        tooltip.style.opacity = '1'

        const triggerRect = this.$el.getBoundingClientRect()
        const tooltipRect = tooltip.getBoundingClientRect()
        const viewportWidth = window.innerWidth
        const padding = 8

        let left = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2)
        left = Math.max(padding, Math.min(left, viewportWidth - tooltipRect.width - padding))
        const top = triggerRect.bottom + 8

        tooltip.style.left = `${left}px`
        tooltip.style.top = `${top}px`
        tooltip.style.transform = 'none'
        tooltip.style.visibility = ''
        tooltip.style.opacity = ''
      })
    }
  }
}
</script>
